<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  width="22"
  height="19"
  viewBox="0 0 22 19"
>
  <path
    fill="evenodd"
    d="M19.534.967H2.467A2.13 2.13 0 0 0 .345 3.1L.334 15.9a2.14 2.14 0 0 0 2.133 2.133h17.067a2.14 2.14 0 0 0 2.133-2.133V3.1A2.14 2.14 0 0 0 19.534.967Zm0 14.933H2.467V5.233l8.534 5.334 8.533-5.334V15.9Zm-8.533-7.467L2.467 3.1h17.067l-8.533 5.333Z"
  />
</svg>
